import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  droppable: {
    borderRadius: UNIT,
    borderWidth: '1px',
    padding: UNIT * 0.25,
    borderStyle: 'dashed',
    borderColor: 'gray'
  },

  defaultCropContainer: {
    position: 'relative',
    width: UNIT * 13.5,
    height: UNIT * 13.5,
    background: mainColor.colorWhite
  },
  cropContainer: {
    position: 'relative',
    width: 'auto',
    height: UNIT * 10.0625,
    backgroundColor: 'rgb(241, 244, 247)'
  },
  iconFile: {
    fontSize: UNIT * 3.125,
    color: 'gray',
    marginTop: UNIT * 1.25,
    marginBottom: UNIT * 0.625
  },
  cropIcon: {
    width: UNIT * 1.875,
    height: UNIT * 1.875,
    backgroundColor: 'transparent',
    position: 'absolute',
    right: UNIT * 0.625,
    top: UNIT * 0.625
  },
  crop: {
    fontSize: UNIT,
    alignSelf: 'center'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: UNIT * 0.5,
    justifyContent: 'center'
  },
  defaultCrop: {
    width: UNIT * 13.5,
    height: UNIT * 13.5,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },

  icon: {
    fontSize: UNIT * 0.8,
    alignSelf: 'center',
    backgroundColor: 'transparent',
    color: mainColor.colorWhite
  },

  arroundIcon: {
    display: 'flex',
    padding: UNIT * 0.25,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    backgroundColor: mainColor.colorDarkGray,
    right: -UNIT * 0.6,
    top: -UNIT * 0.6,
    zIndex: 1
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    width: '98%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: mainColor.colorWhite
  },
  image: {
    width: 'auto',
    height: 'auto'
  },
  addIcon: {
    fontSize: 'xx-large',
    color: 'darkgray',
    cursor: 'pointer'
  }
});
